import Layout from '@/views/layout'

export default [{
    path: '/ay-information-center',
    component: Layout,
    redirect: '/news-info/index',
    meta: {
        title: 'menu.infoCenter' // 信息中心
    },
    children: [
        {
            path: 'news-info/index',
            component: () => import('@/views/ay-information-center/news-info/index'),
            name: 'News',
            meta: { title: 'ic.news.information' }  // 新闻资讯
        },
        {
            path: 'news-info/view',
            component: () => import('@/views/ay-information-center/news-info/view'),
            name: 'NewsView',
            meta: { title: 'News.details'} ,  // 新闻详情
            hidden: true
        },
        {
            path: 'list-files/index',
            component: () => import('@/views/ay-information-center/list-files/index'),
            name: 'Data',
            meta: { title: 'ic.listFiles' }  // 文件资料
        },
        {
            path: 'service-message/index',
            component: () => import('@/views/ay-information-center/service-message/index'),
            name: 'AdvisoryMessage',
            meta: { title: 'ic.service.message' }  // 留言咨询
        },
        {
            path: 'edit-advisory-message',
            component: () => import('@/views/ay-information-center/service-message/edit-advisory-message'),
            name: 'EditAdvisoryMessage',
            meta: { title: 'ic.service.message' }, // 留言咨询
            hidden: true
        }
    ]
}]
